import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from '@/components/ui/card';
import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import PATH_PAGE from '@/router/path';
import { SquarePlayIcon } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { WrapTableAndSheet } from '../../tasks/tasks';
import { RouteParams } from '@/router/type';
import { useListServerlessTasks } from '@/service/serverless-gpu/hook';
import { TypeServerless } from '@/service/serverless-gpu/type';
import { compareDateDesc } from '@/utils/date';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
const ServerlessGpuDevelop = () => {
  const { orgId, workspaceId } = useParamWorkspaceId();
  const { projectId } = useParams<RouteParams>();

  const { data: dataTasks } = useListServerlessTasks({
    project_id: projectId!,
  });
  const tasks =
    dataTasks?.tasks
      ?.filter((item) =>
        [TypeServerless.Manual, TypeServerless.Spot].includes(item.trigger_type)
      )
      .sort(compareDateDesc('created_at')) || [];

  return (
    <>
      <div className="container mt-8">
        <div className="flex justify-between gap-2">
          <p className="text-base font-semibold">Develop</p>
          {/* {isFoundTask && (
            <Link
              to={PATH_PAGE.dashboard.serverlessGPU.onboarding(workspaceId)}
            >
              <Button>Run your Project</Button>
            </Link>
          )} */}
        </div>
        <div className="mt-3 grid gap-6">
          {/* {isFoundTask ? <WrapTableAndSheet data={mockData} /> : <DemoCreate />} */}
          <DemoCreate />
          <div>
            <div className="text-base font-semibold">Tasks</div>
            <WrapTableAndSheet
              data={tasks?.map((item) => ({
                id: item.id,
                status: item.status,
                name: item.name,
                created_at: item.created_at,
                type: item.trigger_type,
              }))}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ServerlessGpuDevelop;

const DemoCreate = () => {
  const { orgId, workspaceId } = useParamWorkspaceId();
  return (
    <Alert variant={'default'}>
      <SquarePlayIcon className="h-4 w-4" />
      <AlertTitle>Run Your Project</AlertTitle>
      <AlertDescription>
        To run the code with serverless GPU,{' '}
        <Link
          to={PATH_PAGE.dashboard.serverlessGPU.onboarding(orgId, workspaceId)}
          className="underline"
        >
          Full Quickstart guide.
        </Link>
        <div className="mt-4 flex max-w-[800px] flex-col gap-4">
          <div className="grid gap-1">
            <p className="text-sm font-semibold">Mode Manual</p>
            <SyntaxHighlighter language="bash" showCopy>
              {`float16 run <YOUR_FILE.py> --name example`}
            </SyntaxHighlighter>
          </div>
          <div className="grid gap-1">
            <p className="text-sm font-semibold">Mode Spot</p>
            <SyntaxHighlighter language="bash" showCopy>
              {`float16 run <YOUR_FILE.py> --name example --spot`}
            </SyntaxHighlighter>
          </div>
          <Link
            to="https://github.com/float16-cloud/examples/tree/main/official"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant={'link'}
              endIcon={<ArrowTopRightIcon />}
              className="px-0"
            >
              Go to our examples
            </Button>
          </Link>
        </div>
      </AlertDescription>
    </Alert>
  );
};
